// @ts-nocheck
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

function useHistoryState(key, initialValue) {
  const history = useHistory();
  const [localState, setLocalState] = useState(
    _.defaultTo(history.location.state?.[key], initialValue)
  );

  useEffect(() => {
    const state = _.defaultTo(history.location.state, {});
    history.replace(history.location.pathname, {
      ...state,
      [key]: localState,
    });
  }, [history, key, localState]);

  return [localState, setLocalState];
}

export default useHistoryState;
